<div class="fondo">
    <img src="/assets/proximamenteweb.png" class=" img-fluid rounded-pill" alt="...">
</div>

 
